import React, { Component } from "react";
import { Button, Modal, Typography, Form, Select, message, Spin } from 'antd';
import { renderMontoTransaccion } from "../../Utils";


const { Title } = Typography;
const { Option } = Select;
const axios = require('axios').default;

/**
 *
 *
 * @class modal_form
 * @extends {Component}
 */
class ModalAsociacionFacturasTransacciones extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            orden: undefined,
            facturas: {
                data: [],
                loading: false,
                page: 1,
                limit: 10,
                total: 0,
                filtroSearch: '',
                searching: true,

            },
            transacciones: {
                data: [],
                loading: false,
                page: 1,
                limit: 10,
                total: 0,
                filtroSearch: '',
                searching: true,

            },

        }
    }

    modal_form = React.createRef();

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

        if (this.props.factura_id !== undefined) {
            this.getFactura();
            this.getTransacciones()
        }
        if (this.props.transaccion_id !== undefined) {
            this.getTransaccion();
            this.getFacturas();
        }
    }



    /**
       *
       *
       * @memberof ModalAsociacionFacturasTransacciones
       * @method getTransaccion
       * @description Obtiene la informacion si el modal tiene transaccion_id
       * 
       */
    getTransaccion = () => {
        axios.get(`/transacciones/${this.props.transaccion_id}`, {
            params: {
                id: this.props.transaccion_id,
            }
        }).then(({ data }) => {
            console.log("{data}", data);

            this.setState({ transaccion: data });
        })
            .catch(error => {
                console.log('error', error.response)
            })


    }

    /**
     * @memberof ModalAsociacionFacturasTransacciones
     * @method getFactura
     * @description Se ejecuta solo si el formulario tiene factura_id en propiedades
     * 
     */
    getFactura = () => {
        axios.get('/facturas/'+ this.props.factura_id, {
            params: { 
                id: this.props.factura_id,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(async response => {
            let factura = response.data.data
            this.setState({
                factura: factura,
                disabled: factura.syncfy_id ? true : false,
            })

        }).catch(error => {
            console.log(error)
            message.error('Error al traer la factura')
        }).finally(() => {

            this.setState({ loading: false, disabled: true })
        })
    }


    /**
       *
       *
       * @memberof ModalAsociacionFacturasTransacciones
       * @method getFacturas
       * @description Obtiene todas todas las facturas
       * 
       */
    getFacturas = (
        {
            page = this.state.facturas.page,
            limit = this.state.facturas.limit,
            search = this.state.facturas.search,

        } = this.state.facturas,
        { facturas } = this.state,
    ) => {
        facturas.loading = true;
        facturas.page = page;
        facturas.limit = limit;
        facturas.search = search;

        this.setState({ facturas })

        axios.get('/facturas', {
            params: {
                page,
                limit,
                search,
                sin_transacciones: true
            }
        })
            .then(response => {
                console.log('res facturas', response)
                let facturas = {
                    data: response.data.data,
                    page: response.data.page,
                    total: response.data.total,
                    filtroSearch: search,
                    searching: true,
                    loading: false
                }
                this.setState({
                    facturas
                })
            })
            .catch(error => {
                message.error('Error al Cargar las facturas')
                console.log(error)
            })

    }


    /**
       *
       *
       * @memberof ModalAsociacionFacturasTransacciones
       * @method getTransacciones
       * @description Obtiene todas todas las transacciones
       * 
       */
    getTransacciones = (
        {
            page = this.state.transacciones.page,
            limit = this.state.transacciones.limit,
            search = this.state.transacciones.search,

        } = this.state.transacciones,
    ) => {

        axios.get('/transacciones', {
            params:{
                page,
                limit,
                search,
            }
        })
            .then(({ data }) => {
                console.log('res transacciones', data)
                let transacciones = {
                    data: data.data,
                    page: data.page,
                    total: data.total,
                    perPage: data.limit,
                    pages: data.pages,
                    filtroSearch: search,
                    searching: true,
                    loading: false
                }
                this.setState({
                    transacciones
                })
            })
            .catch(res => {
                console.log("error", res);
                message.error('No se pudieron cargar las transacciones')
            })
    }




    /**
      *
      *
      * @memberof ModalAsociacionFacturasTransacciones
      * @description Se ejecuta al hacer click en guardar
      * @param values datos del form
      */
    onFinish = (values) => {

        if(this.state.loading) return
        
        this.setState({ loading: true }, () => {

            if (this.props.factura_id !== undefined) {
                axios.put('/transacciones', {
                    asignar_factura: true,
                    factura_id: this.props.factura_id,
                    id: values.transaccion_id,
                    
                })
                    .then(res => {
                        console.log('res factura asignar', res)
                        message.success('Se asigno factura a transacción')
                    })
                    .catch(error => {
                        console.log(error)
                        message.error('No se puso asignar factura a transacción')
                    })
                    .finally(() => {
                      this.setState({loading: false}, () => this.props.onClose())
                    })
            }
            else {
                axios.put('/transacciones', {
                    asignar_factura: true,
                    id: this.props.transaccion_id,
                    ...values
                })
                    .then(res => {
                        console.log('res transaccion asignar', res)
                        message.success('Se asigno transacción a factura')
    
                    })
                    .catch(error => {
                        console.log(error)
                        message.error('No se puso asignar transacción a factura')
                    })
                    .finally(() => {
                      this.setState({loading: false}, () => this.props.onClose())
                    })
    
            }
        })



    }

    render() {

        const layout = {
            labelCol: { span: 24 },
            wrapperCol: { span: 24 },
        };
        return (
            <Form layout="vertical" name="form-asociacion" {...layout} onFinish={this.onFinish} >
            {(this.props.factura_id !== undefined) ?
                <Form.Item label="Transacciones" name="transaccion_id" >
                <Select
                    placeholder="Buscar transacción"
                    showSearch
                    onSearch={(search) => this.getTransacciones({search})}
                    filterOption={false}
                >
                    {this.state.transacciones.data.map(transaccion => {
                    return (
                        <Option value={transaccion._id} key={transaccion._id}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontWeight: 'bold' }}>
                                    {transaccion.concepto || transaccion.cliente_id?.razon_social || transaccion.cliente_id?.nombre}
                                    <span style={{ fontWeight: 'normal', color: 'gray', marginLeft: '10px' }}>
                                        ({new Date(transaccion.fecha).toLocaleDateString() || 'Sin fecha'})
                                    </span>
                                </span>
                                <span style={{ color: 'gray', fontSize: '12px' }}>Orden: {transaccion.orden_id?.folio || 'N/A'}</span>
                                <span style={{ color: 'gray', fontSize: '12px' }}>Orden de Compra: {transaccion.orden_compra_id?.folio || 'N/A'}</span>
                                {renderMontoTransaccion({monto: transaccion.monto, tipo: transaccion.tipo})}
                            </div>
                        </Option>
                    );
                    })}
                </Select>
                </Form.Item>
                :
                <Form.Item label="Facturas" name="factura_id" >
                <Select
                    placeholder="Seleccione el Folio"
                    showSearch
                    onSearch={(search) => this.getFacturas({ search })}
                    filterOption={false}
                >
                    {this.state.facturas.data.map(factura => {
                    return (
                        <Option value={factura._id} key={factura._id}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontWeight: 'bold' }}>{factura.concepto || factura.proveedor_id?.nombre}</span>
                            <span style={{ color: 'gray', fontSize: '12px' }}>Orden: {factura.orden_id?.folio || 'N/A'}</span>
                            <span style={{ color: 'gray', fontSize: '12px' }}>Proveedor: {factura.proveedor_id?.nombre || 'N/A'}</span>
                            <span style={{ color: 'green', fontSize: '14px', fontWeight: 'bold' }}>Monto: ${factura.monto?.toFixed(2) || '0.00'}</span>
                        </div>
                        </Option>
                    );
                    })}
                </Select>
                </Form.Item>
            }
            </Form>
        )
    }
}



export default function (props) {
    const { visible = false, onClose = () => { }, factura_id } = props

    return <Modal
        visible={visible}
        onCancel={onClose}
        title={`Asignar ${factura_id ? 'Transacción a Factura' : 'Factura a Transacción'}`}
        /* footer={null} */
        closable={true}
        destroyOnClose={true}
        zIndex={1000}
        cancelText="Cancelar"
        okText="Guardar"
        okButtonProps={{ form: 'form-asociacion', key: 'submit', htmlType: 'submit' }}
    >
        <ModalAsociacionFacturasTransacciones {...props} />
    </Modal>

}